import { DISMISS_NOTIFICATION, DISPLAY_NOTIFICATION, NotificationActionTypes } from './types';

export const displayNotification = (message: string): NotificationActionTypes => ({
  type: DISPLAY_NOTIFICATION,
  payload: { message },
});

export const dismissNotification = (): NotificationActionTypes => ({
  type: DISMISS_NOTIFICATION,
});
